import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import Widgets from "views/admin/default/components/Widgets";
import CheckTable from "views/admin/default/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";

import ProvincesTable from "./components/ProvincesTable";

const Dashboard = () => {
  return (
    <div>
      <Widgets />

      <div className="mt-5 w-full">
        <TotalSpent />
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5">
        <ComplexTable />
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-3 items-start">
        <div className="col-span-1 xl:col-span-2">
          <ProvincesTable />
        </div>
        <PieChartCard />
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5">
        <CheckTable />
      </div>
    </div>
  );
};

export default Dashboard;
